module.exports = __webpack_public_path__ + "img/Mortgage.b69af7f9.svg";